import { useSyncExternalStore } from 'react';

const TICK_MS = 250;

/** The current quarter-second; read on demand, so it is never stale after a period of no ticking. */
const readTick = () => Math.floor(Date.now() / TICK_MS);

function subscribeToTicks(listener: () => void): () => void {
  const id = setInterval(listener, TICK_MS);
  return () => clearInterval(id);
}

const noSubscription = () => () => undefined;

/** Whole seconds until `deadline` (epoch ms), ticking while set; null when there is none. */
export function useSecondsUntil(deadline: number | null): number | null {
  const tick = useSyncExternalStore(
    deadline === null ? noSubscription : subscribeToTicks,
    readTick,
  );
  if (deadline === null) return null;
  return Math.max(0, Math.ceil((deadline - tick * TICK_MS) / 1000));
}
